import React, { useEffect, useMemo, useRef, useState } from "react";
import SceneManager from "../Viewer3D";
import { emptyToothStlFiles, formulaBase, formulaBones, formulaGaps, formulaProsthesis, formulaSinuses, formulaToothPartRules, getFormulaToothStl } from "../Formula/FormulaStl";
import { toothTypes } from "../Formula/tooth";
import { gapsTypes } from "../Formula/gaps";
import { prosthesisTypes } from "../Formula/prosthesis";
import Formula3DPreviewControls from "./Formula3DPreviewControls";
import DesktopWindowsIcon from "@mui/icons-material/DesktopWindows";
import { Button, Slider } from "@mui/material";
import "./index.scss";
import whatsNext from "./whatsNext2.gif";
import { baseTypes } from "../Formula/base";
import IconTop from "./Formula3DPreviewControls/controlIcons/controlsTop.png";
import IconBottom from "./Formula3DPreviewControls/controlIcons/controlsBottom.png";
import IconBase from "./Formula3DPreviewControls/controlIcons/controlsBase.png";
import IconFixedProstheses from "./Formula3DPreviewControls/controlIcons/controlsFixedProstheses.png";
import IconRemovableProsthetics from "./Formula3DPreviewControls/controlIcons/controlsRemovableProsthetics.png";
import IconImplants from "./Formula3DPreviewControls/controlIcons/controlsImplants.png";
import IconAbutments from "./Formula3DPreviewControls/controlIcons/controlsAbutments.png";
import IconMultiunitAbutments from "./Formula3DPreviewControls/controlIcons/controlsMultiunitAbutment.png";
import IconScrews from "./Formula3DPreviewControls/controlIcons/controlsScrews.png";
import IconSyntheticGum from "./Formula3DPreviewControls/controlIcons/controlsSyntheticGum.png";
import IconStumpTabs from "./Formula3DPreviewControls/controlIcons/controlsStumpTabs.png";
import IconSeparations from "./Formula3DPreviewControls/controlIcons/controlsSeparations.png";
import IconSinuses from "./Formula3DPreviewControls/controlIcons/controlsSinuses.png";
import IconJoint from "./Formula3DPreviewControls/controlIcons/controlsJoint.png";
import IconOrthoSystems from "./Formula3DPreviewControls/controlIcons/controlsOrthoSystems.png";
import IconHead from "./Formula3DPreviewControls/controlIcons/controlsHead.png";
import IconSkull from "./Formula3DPreviewControls/controlIcons/controlsSkull.png";
import { TranslateProvider, useTranslation } from "../../i18n";
let sceneManager = null;
const slideRegex = /^slide/gm;

const Formula3DPreview = ({
  stlPack = null,
  stlPack2 = null,
  availableSwitchers,
  hideNotUsedSides = true,
  hideJawStateSwitcher = true,
  jawStateEnabled = false,
  hideHeadMaskSwitcher = true,
  headMaskEnabled = false,
  headMaskType = "man_face10",
  animate = false,
  cameraZoom = 15,
  onLoaded = () => {},
  whatNextBtn = false,
  generateCanvas3DRef = null,
  sectionSelect = false,
  sectionName = null,
  sectionAction = null,
  selectableMask = null
}) => {
  const {
    _t,
    language,
    setLanguage
  } = useTranslation();
  const renderWrapper = useRef();
  let rendererContainer = useRef();
  const init3d = useRef(false);

  function createRenderRef(node) {
    rendererContainer.current = node;

    if (typeof generateCanvas3DRef === "function") {
      generateCanvas3DRef(node);
    }
  }

  const resetControls = () => {
    sceneManager.resetControls();
  };

  const [switchers, setSwitchers] = useState([]);
  useEffect(() => {
    function getSwitchers(available, sides) {
      let switchersLocal = [];

      if (!available || !available.length) {
        available = ["top", "bottom"];
      }

      switchersLocal.push({
        name: "top",
        label: _t("Верхняя челюсть"),
        icon: IconTop,
        checked: sides.includes("top"),
        hidden: !available.includes("top")
      });
      switchersLocal.push({
        name: "bottom",
        label: _t("Нижняя челюсть"),
        icon: IconBottom,
        checked: sides.includes("bottom"),
        hidden: !available.includes("bottom")
      });

      if (available.includes("softTissue")) {
        switchersLocal.push({
          name: "softTissue",
          label: _t("Мягкие ткани"),
          icon: IconHead,
          checked: true,
          hidden: false
        });
      }

      if (available.includes("skull")) {
        switchersLocal.push({
          name: "skull",
          label: _t("Череп"),
          icon: IconSkull,
          checked: true,
          hidden: false
        });
      }

      if (available.includes("base")) {
        switchersLocal.push({
          name: "base",
          label: _t("Базовая модель"),
          icon: IconBase,
          checked: true,
          hidden: false
        });
      }

      if (available.includes("fixedProstheses")) {
        switchersLocal.push({
          name: "fixedProstheses",
          label: _t("Протез, реставрация"),
          icon: IconFixedProstheses,
          checked: true,
          hidden: false
        });
      }

      if (available.includes("removableProsthetics")) {
        switchersLocal.push({
          name: "removableProsthetics",
          label: _t("Съемные конструкции"),
          icon: IconRemovableProsthetics,
          checked: true,
          hidden: false
        });
      }

      if (available.includes("implants")) {
        switchersLocal.push({
          name: "implants",
          label: _t("Импланты"),
          icon: IconImplants,
          checked: true,
          hidden: false
        });
      }

      if (available.includes("abutments")) {
        switchersLocal.push({
          name: "abutments",
          label: _t("Абатменты"),
          icon: IconAbutments,
          checked: true,
          hidden: false
        });
      }

      if (available.includes("multiunitAbutments")) {
        switchersLocal.push({
          name: "multiunitAbutments",
          label: _t("Мульти-юниты"),
          icon: IconMultiunitAbutments,
          checked: true,
          hidden: false
        });
      }

      if (available.includes("screws")) {
        switchersLocal.push({
          name: "screws",
          label: _t("Винты"),
          icon: IconScrews,
          checked: true,
          hidden: false
        });
      }

      if (available.includes("syntheticGum")) {
        switchersLocal.push({
          name: "syntheticGum",
          label: _t("Искусственная десна"),
          icon: IconSyntheticGum,
          checked: true,
          hidden: false
        });
      }

      if (available.includes("stumpTabs")) {
        switchersLocal.push({
          name: "stumpTabs",
          label: _t("Культевые вкладки"),
          icon: IconStumpTabs,
          checked: true,
          hidden: false
        });
      }

      if (available.includes("separations")) {
        switchersLocal.push({
          name: "separations",
          label: _t("Сепарации"),
          icon: IconSeparations,
          checked: true,
          hidden: false
        });
      }

      if (available.includes("sinuses")) {
        switchersLocal.push({
          name: "sinuses",
          label: _t("Синусы, каналы, пластика"),
          icon: IconSinuses,
          checked: true,
          hidden: false
        });
      }

      if (available.includes("joint")) {
        switchersLocal.push({
          name: "joint",
          label: _t("ВНЧС"),
          icon: IconJoint,
          checked: true,
          hidden: false
        });
      }

      if (available.includes("prosthesisAll")) {
        switchersLocal.push({
          name: "prosthesisAll",
          label: _t("Протез, реставрация"),
          icon: IconFixedProstheses,
          checked: true,
          hidden: false
        });
      }

      if (available.includes("orthoSystems")) {
        switchersLocal.push({
          name: "orthoSystems",
          label: _t("Орто. система"),
          icon: IconOrthoSystems,
          checked: true,
          hidden: false
        });
      }

      return switchersLocal;
    }

    function getSides(hide, pack) {
      let sidesComputed = ["top", "bottom"];
      let tList = ["11", "12", "13", "14", "15", "16", "17", "18", "21", "22", "23", "24", "25", "26", "27", "28"];
      let bList = ["31", "32", "33", "34", "35", "36", "37", "38", "41", "42", "43", "44", "45", "46", "47", "48"];

      if (!hide) {
        return sidesComputed;
      } else if (!pack || !pack.hasOwnProperty("tooth")) {
        return [];
      }

      let changedItems = pack.tooth.filter(el => el.toothElementsActive.length > 1 || el.toothElementsActive.length === 1 && el.toothElementsActive.some(el => !["healthyTooth", "oldEsteticTooth"].includes(el)));

      if (!changedItems.length) {
        return [];
      }

      let top = changedItems.some(el => tList.includes(el.name));
      let bottom = changedItems.some(el => bList.includes(el.name));

      if (!top) {
        sidesComputed = sidesComputed.filter(el => el !== "top");
      }

      if (!bottom) {
        sidesComputed = sidesComputed.filter(el => el !== "bottom");
      }

      return sidesComputed;
    }

    setSwitchers(getSwitchers(availableSwitchers, getSides(hideNotUsedSides, stlPack)));
  }, [_t, availableSwitchers, hideNotUsedSides, stlPack]);
  const availableSidesLocal = useMemo(() => {
    return [...switchers.filter(el => ["top", "bottom"].includes(el.name) && el.checked).map(el => el.name)];
  }, [switchers]);
  const sliderEnabled = useMemo(() => {
    return !!stlPack?.prosthesis?.length && stlPack.prosthesis.some(el => el.search(slideRegex) !== -1);
  }, [stlPack]);
  const prepareFiles = useMemo(() => {
    function generateStlFiles(localeStlPack, localAvailableSides, scene) {
      if (!localeStlPack) {
        return [];
      }

      const availableTop = localAvailableSides.includes("top");
      const availableBottom = localAvailableSides.includes("bottom");
      let baseModelsPack = [];

      if (localeStlPack.baseModels && localeStlPack.baseModels.length) {
        baseModelsPack = localeStlPack.baseModels;
      } else if (!sliderEnabled) {
        if (availableTop) {
          baseModelsPack.push("gumTop");
        }

        if (availableBottom) {
          baseModelsPack.push("gumBottom");
        }
      }

      let baseModels = [];

      if (!sectionSelect) {
        baseModels = baseModelsPack.filter(el => availableTop && baseTypes[el].position === "top" || availableBottom && baseTypes[el].position === "bottom").reduce((all, item) => {
          return [...all, ...formulaBase[item].files.map(stl => {
            return {
              name: `${item}_${stl.name}`,
              url: require(`../stl/${stl.item}/${stl.name}.stl`),
              progress: 0,
              options: { ...stl
              },
              scene: scene
            };
          })];
        }, []);
      } // Available for both


      let prosthesis = [];

      if (localeStlPack.prosthesis && localeStlPack.prosthesis.length) {
        prosthesis = localeStlPack.prosthesis.filter(el => availableTop && prosthesisTypes[el].position === "top" || availableBottom && prosthesisTypes[el].position === "bottom").reduce((all, item) => {
          let files = [];
          let isSlider = item.search(slideRegex) !== -1;

          if (isSlider) {
            files = formulaProsthesis[item].files.reduce((slidesList, stl) => {
              let slideFiles = [];
              let counter = stl?.counter || 1;

              for (let i = 1; i <= counter; i++) {
                const isSingle = counter === 1;
                let groups = [];
                let slidePrefix = "";

                if (isSingle) {
                  groups = stl.groups ? stl.groups : [];
                } else {
                  groups = stl.groups ? [...stl.groups, `slide_${i}`] : [`slide_${i}`];
                  slidePrefix = `_${i}`;
                }

                slideFiles.push({
                  name: `${stl.item}_${stl.name}_${i}`,
                  url: require(`../stl/slides/${stl.item}/${stl.name}${slidePrefix}.stl`),
                  progress: 0,
                  options: { ...stl,
                    visible: i === 1,
                    groups
                  },
                  scene: scene
                });
              }

              return [...slidesList, ...slideFiles];
            }, []);
          } else {
            files = formulaProsthesis[item].files.map(stl => {
              return {
                name: `${item}_${stl.name}`,
                url: require(`../stl/${stl.item}/${stl.name}.stl`),
                progress: 0,
                options: { ...stl
                },
                scene: scene
              };
            });
          }

          return [...all, ...files];
        }, []);
      }

      let gaps = [];
      const gapsInitial = gapsTypes.reduce((summ, el) => ({ ...summ,
        [el.name]: el
      }), {});

      if (localeStlPack.gaps && localeStlPack.gaps.length) {
        let tavailableSides = gapsTypes.filter(el => availableTop && el.position === "top" || availableBottom && el.position === "bottom").map(el => el.name);
        const currentGapsList = localeStlPack.gaps.filter(el => tavailableSides.includes(el.name));
        gaps = currentGapsList.reduce((all, item) => {
          let types = [];

          if (typeof item.separation === "boolean") {
            if (item.separation) {
              types.push("separation");
            }
          } else if (typeof item.separation === "object") {
            if (item.separation.isActive) {
              types.push("separation");
            }
          }

          if (typeof item.connection === "boolean") {
            if (item.connection) {
              types.push("connection");
            }
          } else if (typeof item.connection === "object") {
            if (item.connection.isActive) {
              types.push("connection");
            }
          }

          if (typeof item.miniImplant === "boolean") {
            if (item.miniImplant) {
              types.push("miniImplant");
            }
          } else if (typeof item.miniImplant === "object") {
            if (item.miniImplant.isActive) {
              types.push("miniImplant");
            }
          }

          if (types.length) {
            const files = types.reduce((allFiles, type) => {
              return [...allFiles, ...formulaGaps[type].map(stl => {
                return {
                  name: `${item.name}_${stl.item}`,
                  url: require(`../stl/${stl.item}/${item.name}.stl`),
                  progress: 0,
                  options: { ...stl,
                    groups: [...stl.groups, gapsInitial[item.name].position]
                  },
                  scene: scene
                };
              })];
            }, []);
            return [...all, ...files];
          }

          return [...all];
        }, []);
      }

      let jointDisease = [];
      let mandibularCanal = [];
      let sinuses = [];

      if (localeStlPack.sinuses && localeStlPack.sinuses.length) {
        let sinusesRules = localeStlPack.sinuses.reduce((allRules, rule) => [...allRules, ...formulaSinuses[rule].rules], []);
        sinuses = localeStlPack.sinuses.reduce((allFiles, file) => [...allFiles, ...formulaSinuses[file].files], []).map(file => {
          const presentRule = sinusesRules.find(present => present.item === file.item);
          const stl = presentRule ? presentRule : file;
          return {
            name: `${stl.item}`,
            url: require(`../stl/sinuses/${stl.item}.stl`),
            progress: 0,
            options: { ...stl
            },
            scene: scene
          };
        });
      }

      let bones = [];
      const isSkullEnabled = !!sinuses.length;

      if (isSkullEnabled) {
        let bonesStlPack = formulaBones["skull"].files;
        bones = bonesStlPack.map(file => {
          return {
            name: `${file.item}`,
            url: require(`../stl/basicBones/${file.item}.stl`),
            progress: 0,
            options: { ...file
            },
            scene: scene
          };
        });
      } // If props empty use default props


      let tooth = [];
      let currentToothList = [];

      if (localeStlPack.tooth && localeStlPack.tooth.length) {
        currentToothList = localeStlPack.tooth;
      } else if (!sliderEnabled) {
        currentToothList = toothTypes;
      }

      if (currentToothList) {
        let tavailableSides = toothTypes.filter(el => availableTop && el.position === "top" || availableBottom && el.position === "bottom").map(el => el.name);
        currentToothList = currentToothList.filter(el => tavailableSides.includes(el.name));

        if (sectionSelect) {
          currentToothList = currentToothList.filter(el => el.name === sectionName);
        }

        const onlySkullFiles = ["corticalBoneImplants"];
        tooth = currentToothList.reduce((summ, toothInfo) => {
          let rules = toothInfo.toothElementsActive.reduce((allRules, activity) => {
            return [...allRules, ...getFormulaToothStl("rules", activity, toothInfo.name)];
          }, []);
          let partRules = [];

          if (toothInfo?.toothSegments && Object.keys(toothInfo.toothSegments).length) {
            Object.keys(toothInfo.toothSegments).forEach(typeKey => {
              if (toothInfo.toothSegments[typeKey].length) {
                toothInfo.toothSegments[typeKey].forEach(partKey => {
                  partRules.push(formulaToothPartRules[typeKey][partKey]);
                });
              }
            });
          }

          rules = [...rules, ...partRules];
          let ruledFiles = toothInfo.toothElementsActive.reduce((allFiles, activity) => {
            return [...allFiles, ...getFormulaToothStl("files", activity, toothInfo.name)];
          }, []);

          if (!isSkullEnabled) {
            ruledFiles = ruledFiles.filter(file => !onlySkullFiles.includes(file.item));
          }

          rules = rules.map((el, i, arr) => {
            // Get more then one parameter for current element
            let activeRules = arr.filter(present => present.item === el.item);

            if (activeRules.length > 1) {
              activeRules = activeRules.map(el => el?.importance ? el : { ...el,
                importance: 0
              }).sort((a, b) => {
                if (a.importance < b.importance) {
                  return -1;
                }

                if (a.importance > b.importance) {
                  return 1;
                }

                return 0;
              });
              return activeRules.reduce((sum, el) => {
                return { ...sum,
                  ...el
                };
              }, {});
            }

            return el;
          });
          let stlFiles = [];
          ruledFiles.forEach(file => {
            const presentRule = rules.find(present => present.item === file.item);
            const stl = presentRule ? { ...file,
              ...presentRule
            } : file;
            const position = parseInt(toothInfo.name, 10) < 30 ? "top" : "bottom";
            const groups = file.groups ? [...file.groups, position] : [position];

            if (emptyToothStlFiles[stl.item] && emptyToothStlFiles[stl.item].includes(toothInfo.name)) {
              return;
            }

            let selectable = false;

            if (selectableMask) {
              selectable = stl.item.search(selectableMask) !== -1;
            }

            stlFiles.push({
              name: `${toothInfo.name}_${stl.item}`,
              url: require(`../stl/${stl.path}.stl`),
              progress: 0,
              options: { ...stl,
                groups,
                selectable: selectable
              },
              scene: scene
            });
          });
          return [...summ, ...stlFiles];
        }, []);
      }

      return [...baseModels, ...prosthesis, ...gaps, ...jointDisease, ...mandibularCanal, ...sinuses, ...tooth, ...bones];
    }

    return [...generateStlFiles(stlPack, availableSidesLocal, "main"), ...generateStlFiles(stlPack2, availableSidesLocal, "sub")];
  }, [availableSidesLocal, sectionName, sectionSelect, selectableMask, sliderEnabled, stlPack, stlPack2]);
  useEffect(() => {
    if (!init3d.current) {
      sceneManager = new SceneManager(rendererContainer.current, renderWrapper.current, animate, cameraZoom);
      sceneManager.addScenes(["main"]);
      sceneManager.init();
      init3d.current = true;
    }
  }, [animate, cameraZoom]);
  const [isFullScreen, setIsFullScreen] = useState(false);

  function toggleFullScreen() {
    setIsFullScreen(prev => !prev);
  }

  useEffect(() => {
    if (sceneManager && init3d.current) {
      if (sectionSelect) {
        sceneManager.addOnMeshSelect(sectionAction);
        sceneManager.setCameraZoom(27);
      } else {
        sceneManager.removeOnMeshSelect();
        sceneManager.setCameraZoom(isFullScreen ? 21 : 15);
      }

      sceneManager.resize();
    }
  }, [isFullScreen, sectionAction, sectionSelect]);
  useEffect(() => {
    return () => {
      if (sceneManager && init3d.current) {
        console.log("destroy scene manager");
        sceneManager.destroy();
        sceneManager = null;
      }
    };
  }, []); // Reload models

  useEffect(() => {
    if (sceneManager && init3d.current) {
      sceneManager.loadRemoteFiles(prepareFiles);
      setJawState(false);
      sceneManager.resetGroupsPositions(); // setSwitchers((items) => items.map((el) => ({ ...el, checked: true })));
    }
  }, [prepareFiles]); // Slider switcher

  const [slideIndex, setSlideIndex] = useState(1);

  function switchSlide(val) {
    if (slideIndex !== val) {
      setSlideIndex(val);
    }
  }

  useEffect(() => {
    if (sliderEnabled && stlPack) {
      setSlideIndex(1); // setSwitchers((items) => items.map((el) => ({ ...el, checked: true })));
    }
  }, [sliderEnabled, stlPack]);
  const [jawState, setJawState] = useState(jawStateEnabled);

  function toggleJawState(isChecked) {
    if (!sceneManager || !init3d.current) {
      return;
    }

    if (isChecked) {
      toggleHeadMask(false);
    }

    if (jawState === isChecked) {
      return;
    }

    setJawState(isChecked);
    sceneManager.appendJawAnimation("top", isChecked ? "open" : "close");
    sceneManager.appendJawAnimation("bottom", isChecked ? "open" : "close");
  }

  const [headMask, setHeadMask] = useState(headMaskEnabled);

  function toggleHeadMask(isChecked) {
    if (!sceneManager || !init3d.current) {
      return;
    }

    setHeadMask(isChecked);
    setModelTransparency(!isChecked);

    if (isChecked) {
      toggleJawState(false);
    }
  }

  useEffect(() => {
    if (!sceneManager || !init3d.current) {
      return;
    }

    sceneManager.toggleMaskFiles(headMask ? headMaskType : null);
  }, [headMask, headMaskType]);
  const [modelTransparency, setModelTransparency] = useState(true);
  useEffect(() => {
    if (!sceneManager || !init3d.current) {
      return;
    }

    switchers.forEach(el => {
      sceneManager.setFormulaVisibilityGroup(el.name, el.checked, modelTransparency);
    });

    if (sliderEnabled) {
      for (let i = 1; i <= 10; i++) {
        sceneManager.setFormulaVisibilityGroup(`slide_${i}`, false, modelTransparency);
      }

      sceneManager.setFormulaVisibilityGroup(`slide_${slideIndex}`, true, modelTransparency);
      switchers.forEach(el => {
        if (!el.checked) {
          sceneManager.setModelGroupVisibilityByName(el.name, false);
        }
      });
    }
  }, [modelTransparency, slideIndex, sliderEnabled, switchers]);
  useEffect(() => {
    if (sceneManager && init3d.current) {
      function onLoadedCallback() {
        if (headMask) {
          sceneManager.toggleMaskFiles(headMask ? headMaskType : null);
          switchers.forEach(el => {
            sceneManager.setFormulaVisibilityGroup(el.name, el.checked, false);
          });
        }

        if (sectionSelect) {
          sceneManager.centerModels();
        }

        if (typeof onLoaded === "function") {
          onLoaded();
        }
      }

      sceneManager.addOnLoadEnd(() => {
        onLoadedCallback();
      });
    }
  }, [headMask, headMaskType, onLoaded, sectionSelect, switchers]);
  return /*#__PURE__*/React.createElement("div", {
    className: `formula3dPreview ${isFullScreen ? "fullScreen" : ""}`,
    ref: renderWrapper
  }, /*#__PURE__*/React.createElement("canvas", {
    className: "formula3dPreview-view",
    ref: createRenderRef
  }), sliderEnabled && /*#__PURE__*/React.createElement("div", {
    className: "formula3dPreview-slider"
  }, /*#__PURE__*/React.createElement("div", {
    className: "controlLabel"
  }, _t("До лечения")), /*#__PURE__*/React.createElement(Slider, {
    value: slideIndex,
    marks: true,
    min: 1,
    max: 10,
    step: 1,
    onChange: (e, val) => {
      switchSlide(val);
    },
    style: {
      maxWidth: 600
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "controlLabel"
  }, _t("После лечения"))), sectionSelect && /*#__PURE__*/React.createElement("button", {
    className: "btnPrimary formula3dPreview-sectionSelectRestoreBtn",
    onClick: () => {
      sectionAction();
    }
  }, _t("Показать 3D карту зубов полностью")), whatNextBtn && !prepareFiles.length && /*#__PURE__*/React.createElement("img", {
    src: whatsNext,
    className: "formula3dPreview-whatsNext",
    alt: ""
  }), /*#__PURE__*/React.createElement("div", {
    className: "fullScreenBtn"
  }, /*#__PURE__*/React.createElement("div", {
    className: "fullScreenBtn-icon"
  }, /*#__PURE__*/React.createElement(DesktopWindowsIcon, {
    fontSize: "inherit"
  })), /*#__PURE__*/React.createElement(Button, {
    type: "button",
    color: "primary",
    variant: "outlined",
    size: "small",
    onClick: toggleFullScreen
  }, isFullScreen ? _t("Свернуть") : _t("На весь экран"))), /*#__PURE__*/React.createElement(Formula3DPreviewControls, {
    isFullScreen: isFullScreen,
    switchers: switchers,
    setSwitchers: setSwitchers,
    modelTransparency: modelTransparency,
    setModelTransparency: setModelTransparency,
    jawState: jawState,
    toggleJawState: toggleJawState,
    hideJawStateSwitcher: hideJawStateSwitcher,
    headMask: headMask,
    toggleHeadMask: toggleHeadMask,
    hideHeadMaskSwitcher: hideHeadMaskSwitcher,
    resetControls: resetControls
  }));
};

const Formula3DPreviewWrapper = props => {
  return /*#__PURE__*/React.createElement(TranslateProvider, null, /*#__PURE__*/React.createElement(Formula3DPreview, props));
};

export default Formula3DPreviewWrapper;